const SkeletonNotification = () => {
  return (
    <div className=" max-w-sm animate-pulse border-b-[1px] border-b-[#EEEEEE] py-3">
      <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
      <div className="h-3 bg-gray-300 rounded w-full mb-2"></div>
      <div className="h-3 bg-gray-300 rounded w-5/6 mb-4"></div>
      <div className="h-3 bg-gray-300 rounded w-1/3"></div>
    </div>
  );
};

export default SkeletonNotification;
